import { route } from "../../../../application/domain/routing/named-route";
import { DataTransferTopPage } from "./pages/data-transfer";
import { KintoneExportReportDetailPage } from "./pages/kintone-export-report-detail";
import { KintoneExportSettingCreatePage } from "./pages/kintone-export-setting-create";
import { KintoneExportSettingDetailPage } from "./pages/kintone-export-setting-detail";
import { KintoneExportSettingsPage } from "./pages/kintone-export-settings";

export const ServiceProviderDataTransferRoutes = {
  DataTransferTop: route({
    path: "/service-provider/orgs/:tenantId/data-transfer",
    link: (args: { tenantId: string }) =>
      `/service-provider/orgs/${args.tenantId}/data-transfer`,
    component: DataTransferTopPage,
  }),
  KintoneExportSettings: route({
    path: "/service-provider/orgs/:tenantId/data-transfer/kintone-export-settings",
    link: (args: { tenantId: string }) =>
      `/service-provider/orgs/${args.tenantId}/data-transfer/kintone-export-settings`,
    component: KintoneExportSettingsPage,
  }),
  KintoneExportSettingCreate: route({
    path: "/service-provider/orgs/:tenantId/data-transfer/kintone-export-settings/create",
    link: (args: { tenantId: string }) =>
      `/service-provider/orgs/${args.tenantId}/data-transfer/kintone-export-settings/create`,
    component: KintoneExportSettingCreatePage,
  }),
  KintoneExportSettingDetail: route({
    path: "/service-provider/orgs/:tenantId/data-transfer/kintone-export-settings/:kintoneExportSettingId",
    link: (args: { tenantId: string; kintoneExportSettingId: string }) =>
      `/service-provider/orgs/${args.tenantId}/data-transfer/kintone-export-settings/${args.kintoneExportSettingId}`,
    component: KintoneExportSettingDetailPage,
  }),
  KintoneExportReportDetail: route({
    path: "/service-provider/orgs/:tenantId/data-transfer/kintone-export-settings/:kintoneExportSettingId/reports/:reportId",
    link: (args: {
      tenantId: string;
      kintoneExportSettingId: string;
      reportId: string;
    }) =>
      `/service-provider/orgs/${args.tenantId}/data-transfer/kintone-export-settings/${args.kintoneExportSettingId}/reports/${args.reportId}`,
    component: KintoneExportReportDetailPage,
  }),
};
